import { GetApiResponseByUrl } from '@crossbeam/openapi';

import { createSharedComposable, useAsyncState } from '@vueuse/core';

import { crossbeamApi } from '@/api';
import { captureException } from '@/errors';

export type CreditUsageResponse = GetApiResponseByUrl<'/v0.1/credits/usage'>;

export type CreditUsageClient = CreditUsageResponse['clients'][number];
export type CreditUsageUser = CreditUsageResponse['users'][number];

export default function useCreditUsage() {
  const {
    state: data,
    isLoading,
    error,
    execute: retry,
  } = useAsyncState(
    async () => {
      const { data: response, error: apiError } = await crossbeamApi.GET(
        '/v0.1/credits/usage',
      );
      if (apiError) throw apiError;
      return response ?? null;
    },
    null,
    /* Keep the last numbers on the meter while a retry or the post-purchase
     * refetch is in flight instead of blanking it. */
    { onError: captureException, resetOnExecute: false },
  );

  return { data, isLoading, error, retry };
}

export const useSharedCreditUsage = createSharedComposable(useCreditUsage);
